import { render, staticRenderFns } from "./CoverLetter.vue?vue&type=template&id=752e6c10&scoped=true"
import script from "./CoverLetter.vue?vue&type=script&lang=js"
export * from "./CoverLetter.vue?vue&type=script&lang=js"
import style0 from "./CoverLetter.vue?vue&type=style&index=0&id=752e6c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e6c10",
  null
  
)

export default component.exports